// src/config/appConfig.js

const getEnv = (key) => {
  if (window._env_ && window._env_[key] !== undefined) {
    return window._env_[key];
  }
  return process.env[key];
};

export const appBaseName =
  window.RUNTIME_CONFIG?.REACT_APP_BASE_NAME ||
  process.env.REACT_APP_BASE_NAME;

console.log("process.env.REACT_APP_BASE_NAME",process.env.REACT_APP_BASE_NAME)
export const appAdminModuleName =
  window.RUNTIME_CONFIG?.REACT_APP_ADMIN_MODULE_NAME ||
  process.env.REACT_APP_ADMIN_MODULE_NAME;

export const appBaseUrl =
  window.RUNTIME_CONFIG?.REACT_APP_BASE_URL ||
  process.env.REACT_APP_BASE_URL;

export const appApiUrl =
  window.RUNTIME_CONFIG?.REACT_APP_API_URL ||
  process.env.REACT_APP_API_URL;

export const appVersion =
  window.RUNTIME_CONFIG?.REACT_APP_VERSION ||
  process.env.REACT_APP_VERSION;

export const appEnv =
  window.RUNTIME_CONFIG?.REACT_APP_ENV ||
  process.env.REACT_APP_ENV;

export const static_access_token = window.RUNTIME_CONFIG?.REACT_STATIC_TOKEN ||
  process.env.REACT_STATIC_TOKEN;

// export const appBaseName        = getEnv("REACT_APP_BASE_NAME");
// export const appAdminModuleName = getEnv("REACT_APP_ADMIN_MODULE_NAME");
// export const appBaseUrl         = getEnv("REACT_APP_BASE_URL");
// export const appApiUrl          = getEnv("REACT_APP_API_URL");
// export const appVersion         = getEnv("REACT_APP_VERSION");
// export const appEnv             = getEnv("REACT_APP_ENV");